enum CreateTransactionAction {
  CREATE = "create",
  REPEAT = "repeat",
  RETURN = "return",
}

export { CreateTransactionAction };
